import type { ReactNode } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import 'mantine-datatable/styles.css';
import { store, persistor } from './store';
import { CurrencyProvider } from '@kss/currency';
import { ThemeSync } from '@kss/theme';
import { ToastProvider } from '@kss/ui';

export function Providers({ children }: { children: ReactNode }) {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <MantineProvider>
          <ToastProvider>
            <CurrencyProvider>
              <ThemeSync />
              {children}
            </CurrencyProvider>
          </ToastProvider>
        </MantineProvider>
      </PersistGate>
    </Provider>
  );
}
